import * as i0 from '@angular/core';
import { Directive, HostBinding, Input, NgModule } from '@angular/core';
import { defineCustomElements } from '@ispui/skeleton/loader';

class ISPUISkeletonValueAccessor {
}
ISPUISkeletonValueAccessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISkeletonValueAccessor, deps: [], target: i0.ɵɵFactoryTarget.Directive });
ISPUISkeletonValueAccessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ISPUISkeletonValueAccessor, selector: "ispui-skeleton:not([ngControl]),ispui-skeleton:not([formControlName]),ispui-skeleton[formControl],ispui-skeleton:not([ngFormControl]),ispui-skeleton:not([ngModel])", inputs: { show: "show", width: "width", height: "height" }, host: { properties: { "attr.show": "this.show", "attr.width": "this.width", "attr.height": "this.height" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISkeletonValueAccessor, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ispui-skeleton:not([ngControl]),ispui-skeleton:not([formControlName]),ispui-skeleton[formControl],ispui-skeleton:not([ngFormControl]),ispui-skeleton:not([ngModel])',
                }]
        }], propDecorators: { show: [{
                type: HostBinding,
                args: ['attr.show']
            }, {
                type: Input
            }], width: [{
                type: HostBinding,
                args: ['attr.width']
            }, {
                type: Input
            }], height: [{
                type: HostBinding,
                args: ['attr.height']
            }, {
                type: Input
            }] } });

class ISPUISkeletonModule {
    constructor() {
        defineCustomElements(window);
    }
}
ISPUISkeletonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISkeletonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ISPUISkeletonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISkeletonModule, declarations: [ISPUISkeletonValueAccessor], exports: [ISPUISkeletonValueAccessor] });
ISPUISkeletonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISkeletonModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ISPUISkeletonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ISPUISkeletonValueAccessor],
                    exports: [ISPUISkeletonValueAccessor],
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Generated bundle index. Do not edit.
 */

export { ISPUISkeletonModule, ISPUISkeletonValueAccessor };
